import CONSTANT from '../config/constant'
import Utility from '../utility/Utility'
import ScrollRegister from './ScrollRegister'

export default class Transition extends ScrollRegister {
  constructor() {
    super()
    this.elements = document.getElementsByClassName(CONSTANT.CLASSNAME.TRANSITION)
    this.register()
  }

  register() {
    for (let i = 0, iLength = this.elements.length; i < iLength; i++) {
      const elm       = this.elements[i]
      const top       = Utility.getElementTop(elm)

      this.items.push({elm, top, isAnimated: false})
    }
  }

  onScrollStart(windowTop, windowBottom) {
    this.items.forEach(item => {
      if (item.isAnimated) return false
      if (Utility.isPassed(windowBottom, item.top, 200)) {
        item.isAnimated = true
        setTimeout(() => item.elm.classList.add(CONSTANT.CLASSNAME.ACTIVE), 1)
      }
    })
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/motion/Transition.js